import classNames from "classnames";
import { ParentIcon } from "../../AscIcons";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscBlogCard.module.scss";

export interface AscBlogCardProps {
  className?: string;
  title: string;
  coverImageUrl?: string;
  author?: string;
  onClick?: () => void;
}

export default function AscBlogCard({
  className,
  title,
  coverImageUrl,
  author = "The Edge",
  onClick,
}: AscBlogCardProps) {
  return (
    <AscGenericCard
      title={title}
      coverImageUrl={coverImageUrl}
      data-testid="asc-blog-card"
      className={classNames(styles.ground, className)}
      contentClassName={styles.cardContent}
      onClick={onClick}
    >
      <ParentIcon className={styles.authorIcon} /> {author}
    </AscGenericCard>
  );
}
